module.exports = __webpack_public_path__ + "static/media/40.82bf8abe.mp3";